export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-filter-cf830fd30ac401caeffabdc5e383fa67.svg";